export default {
    podcasts (state) {
      return state.podcasts
    },

    selectedPodcast (state) {
        return state.selectedPodcast
    },

    getPodcast: state => (podcastId) => {
      return state.podcasts().find(podcast => podcast.podcastId === podcastId)
    },
    // ----------------------------------------------------------------------------------------
    advisoryBoard (state) {
      return state.advisoryBoard
    },
    selectedAdvisoryBoard (state) {
      return state.selectedAdvisoryBoard
    },
    getAdvisoryBoard: state => (advisoryBoardId) => {
      return state.advisoryBoard().find(advisoryBoard => advisoryBoard.advisoryBoardId === advisoryBoardId)
    }
    // getAdvBoard: state => (podcastId) => {
    //   return state.podcasts().find(podcast => podcast.podcastId === podcastId)
    // },
}



// WEBPACK FOOTER //
// ./src/store/modules/podcasts/getters.js